const myAccountEventType = 'my_account';

export { myAccountEventType };
//# sourceMappingURL=types.js.map
